export default "/images/375b60ff4a43cbb20277eb290a61c6f5.avif";